export abstract class Provider {
    /* STATIC */

    /* INSTANCE */
    public abstract configure(value: boolean): void;

}
